import React, { useState, useRef, useEffect } from "react";
import "./Card.css";
import Button from "../Button/Button";

function Card({ food, currentCount, totalCartQuantity, onAdd, onRemove }) {
  const [isShaking, setIsShaking] = useState(false);
  const pendingAdd = useRef(false);
  const { title, price, availableQty } = food;

  // Use Redux count directly (no local state)
  const count = currentCount || 0;

  // Detect when + was clicked but count didn't change (limit hit)
  useEffect(() => {
    if (pendingAdd.current) {
      pendingAdd.current = false;
    }
  }, [currentCount]);

  const triggerShake = () => {
    setIsShaking(true);
    setTimeout(() => {
      setIsShaking(false);
    }, 1000);
  };

  const handleIncrement = () => {
    const prevCount = currentCount || 0;
    onAdd(food, 1);
    // After dispatch, if count won't change, Redux returns same state
    // so useEffect won't fire. Use a microtask to check.
    pendingAdd.current = true;
    setTimeout(() => {
      if (pendingAdd.current) {
        // Count didn't change — limit was hit
        pendingAdd.current = false;
        triggerShake();
      }
    }, 50);
  };

  const handleDecrement = () => {
    onRemove(food, 1);
  };

  return (
    <div className="card">
      <span
        className={`${count !== 0 ? "card__badge" : "card__badge--hidden"} ${
          isShaking ? "shake" : ""
        }`}
      >
        {count}
      </span>
      <div className="product__image__container">
        🍼
      </div>
      <div className="card__title__container">
        <div className="card__title">{title}</div>
        <span className="card__price">${price}</span>
      </div>

      <div className="btn-container">
        {count !== 0 ? (
          <Button title={"-"} type={"subtract"} onClick={handleDecrement} />
        ) : (
          ""
        )}
        <Button
          title={`${count !== 0 ? "+" : "ADD"}`}
          type={"add"}
          onClick={handleIncrement}
        />
      </div>
    </div>
  );
}

export default Card;
